var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 4.3c-.3-.4-.6-.7-1-.8-.5-.1-1 0-1.4.2-.6.3-1 .9-1.4 1.4L16 7l-.3.8a22.5 22.5 0 0 0-1.7 5c-.8-.5-1.3-.9-1.5-1.4l-.7-1.8s-.4-1.2-1-1.4C10 8 9.3 8.2 9 8.6a13.8 13.8 0 0 0-3.4 9c0 2.9 1.1 5.7 3.4 7.8a11.8 11.8 0 0 0 16.1 0c2.3-2.1 3.4-5 3.4-7.7 0-2.8-1.1-5.8-3.4-8A19 19 0 0 1 21 4.3ZM16 22.7v-1.3H12v-1.7h3.5v-1.4H12v-1.5h4v-1.4h-5.8v7.3h6Zm.5-7.3h1.7v7.3h-1.7v-7.3Zm5.4 7.3h1.9l-1.7-2.3c.5-.2.9-.5 1.2-1a2.5 2.5 0 0 0 0-2.8c-.3-.4-.7-.7-1.2-.9-.5-.2-1-.3-1.8-.3H19v1.4h1.3c.6 0 1 0 1.3.3.2.2.4.5.4 1 0 .4-.2.7-.4.9-.3.2-.7.3-1.3.3H19v1.4h1.5l1.5 2Z",
    fill: "#8F9BBA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFire);
export default __webpack_public_path__ + "static/media/fire.a70d6982d4c983ed6fed21c5e4fd4a7d.svg";
export { ForwardRef as ReactComponent };